"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var _require = require("../helpers/internal-constants"),
  domSymbolTree = _require.domSymbolTree;
var _require2 = require("../helpers/namespaces"),
  SVG_NS = _require2.SVG_NS;
var _require3 = require("../../utils"),
  mixin = _require3.mixin;
var SVGAnimatedString = require("../generated/SVGAnimatedString");
var ElementImpl = require("./Element-impl").implementation;
var ElementCSSInlineStyleImpl = require("./ElementCSSInlineStyle-impl").implementation;
var GlobalEventHandlersImpl = require("./GlobalEventHandlers-impl").implementation;
var HTMLOrSVGElementImpl = require("./HTMLOrSVGElement-impl").implementation;
var SVGElementImpl = /*#__PURE__*/function (_ElementImpl) {
  _inherits(SVGElementImpl, _ElementImpl);
  var _super = _createSuper(SVGElementImpl);
  function SVGElementImpl(globalObject, args, privateData) {
    var _this;
    _classCallCheck(this, SVGElementImpl);
    _this = _super.call(this, globalObject, args, privateData);
    _this._initHTMLOrSVGElement();
    _this._initElementCSSInlineStyle();
    _this._initGlobalEvents();
    return _this;
  }

  // Keep in sync with HTMLElement. https://github.com/jsdom/jsdom/issues/2599
  _createClass(SVGElementImpl, [{
    key: "_attrModified",
    value: function _attrModified(name, value, oldValue) {
      if (name === "style" && value !== oldValue && !this._settingCssText) {
        this._settingCssText = true;
        this._style.cssText = value;
        this._settingCssText = false;
      } else if (name.startsWith("on")) {
        this._globalEventChanged(name.substring(2));
      }
      _get(_getPrototypeOf(SVGElementImpl.prototype), "_attrModified", this).call(this, name, value, oldValue);
    }
  }, {
    key: "className",
    get: function get() {
      return SVGAnimatedString.createImpl(this._globalObject, [], {
        element: this,
        attribute: "class"
      });
    }
  }, {
    key: "ownerSVGElement",
    get: function get() {
      var e = domSymbolTree.parent(this);
      while (e && e.namespaceURI === SVG_NS) {
        if (e.localName === "svg") {
          return e;
        }
        e = domSymbolTree.parent(e);
      }
      return null;
    }
  }, {
    key: "viewportElement",
    get: function get() {
      // TODO: <symbol>/<use> may make this different from ownerSVGElement.
      return this.ownerSVGElement;
    }
  }]);
  return SVGElementImpl;
}(ElementImpl);
SVGElementImpl.attributeRegistry = new Map();
mixin(SVGElementImpl.prototype, ElementCSSInlineStyleImpl.prototype);
mixin(SVGElementImpl.prototype, GlobalEventHandlersImpl.prototype);
mixin(SVGElementImpl.prototype, HTMLOrSVGElementImpl.prototype);
exports.implementation = SVGElementImpl;